/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Tracking_Declinedeal2Inputs */

const en_coinvestments_tracking_declinedeal2 = /** @type {(inputs: Coinvestments_Tracking_Declinedeal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decline Opportunity`)
};

/**
* | output |
* | --- |
* | "Decline Opportunity" |
*
* @param {Coinvestments_Tracking_Declinedeal2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_tracking_declinedeal2 = /** @type {((inputs?: Coinvestments_Tracking_Declinedeal2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Tracking_Declinedeal2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_tracking_declinedeal2(inputs)
});
export { coinvestments_tracking_declinedeal2 as "coInvestments_tracking_declineDeal" }